import {store} from "../App";
import moment from 'moment/moment';

export function clearCruises() {
    store.dispatch({type: "CLEAR_CRUISES"});
}

export function setCruises(cruises) {
    const cruiseDates = cruises.length ? cruises.map(cruise => moment(cruise.fromDate, 'DD/MM/YYYY')) : null;
    const cruiseStartDate = cruiseDates ? moment.min(cruiseDates).format("DD/MM/YYYY") : null;

    store.dispatch({
        type: "SET_CRUISES",
        cruises,
        cruiseStartDate
    });
}

export function setCruiseImage(results) {
    let imageReferenceId = null;

    if (results && results[0] && results[0].excursion) {
        imageReferenceId = results[0].excursion.id;
    }

    store.dispatch({type: "SET_CRUISE_IMAGE_REFERENCE", imageReferenceId});
}

export function getCurrentCruisesFromStore() {
    return store.getState().cruises;
}